
				var addMethods = require("../../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["getCompleteDataArrayInTimeRange","getAxisMinTimestamp","getSeriesFeaturesDataForEcharts","getSeriesGroupDataForEcharts","getDatasetFeaturesDataForEcharts","getSortedFeaturesValuesByProperty","getGroupedValuesByProperty","getGroupedValuesByTimeBucket","getGroupedValuesByPropertySplitByProperty","getGroupedValuesByTimeBucketSplitByProperty"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "c9f0f1de8b67b374d8a2.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			